import {
    AnalyticsApi,
    useAPIQuery,

} from "melco-shared-logic";

export const useUserWizardsData = (userId?: string) => {

    return useAPIQuery(
        AnalyticsApi,
        ["accountWizardsList"],
        async (api) => {


            //const api = new UserAccountApi(baseApiConfig({ token, impersonationForId: userId }));

            //api.defaultsGetReferralList
            const response = await api.analytcisGetUserWizards();

            return response;
        },
        {
            queryOptions: {
                keepPreviousData: true,
            },
            apiConfigOptions: {
                impersonationForId: userId ?? ""
            }
        }
    );
};
